import { ValidationMessage, FormLabel } from "../../../shared/components";

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    drillingEntry: {
      type: Object,
      default: null
    },
    readOnly : {
      type: Boolean,
      default: false
    },
    description : {
      type: String,
      default: ""
    }
  },
  components: {
    ValidationMessage,
    FormLabel
  },
  data () {
    return {
      model: [],
      isPopupActive:this.$props.isActive,
      activePrompt:false
    }
  },
  watch: {    
    isActive(val) {
      this.isPopupActive = val;
    },
    isPopupActive(val) {
      if (val === false) {
        this.closePopup();
      }
    },
    drillingEntry(newVal) {
      if (newVal) this.model = structuredClone(newVal.notes);      
      else this.model = [];
    }
  },
  computed: {
    title() {
      return this.description + " - " + this.$t('Drilling.DrillEntries.NotesTitle');
    }
  },
  methods: {
    submitNotes() {
      const clonedModel = structuredClone(this.model);
      return this.$refs.notesPromptObserver.validate().then(() => {
        this.$emit('submit', clonedModel);
      });
    },
    closePopup() {
      this.$emit('closePopup');
    },
    addNote() {
      this.model.push({
        id:0,
        note:'', 
        stagingDrillingEntryId: this.drillingEntry.stagingDrillingEntryId,
        modifiedBy: this.$auth.getUser().username,
        modificationDate: new Date().toISOString()
      });

      if (this.model.length === 1) {
        this.model[0].from = this.drillingEntry.from;
        this.model[0].to = this.drillingEntry.to;
      }
      else {
        const latestNote = this.model[this.model.length - 2];
        this.model[this.model.length - 1].from = latestNote.to;
        this.model[this.model.length - 1].to = this.drillingEntry.to;
      }
    },
    deleteNote(item) {
      const index = this.model.indexOf(item);
      this.model.splice(index, 1);
    },
    isValidFrom(tr) {
      return parseInt(tr.from) >= this.drillingEntry.from && parseInt(tr.from) <= this.drillingEntry.to;
    },
    isValidTo(tr) {
      return parseInt(tr.to) <= this.drillingEntry.to && parseInt(tr.to) >= parseInt(tr.from);
    },
    onNoteChanged(tr) {
      tr.modifiedBy = this.$auth.getUser().username;
      tr.modificationDate = new Date().toISOString();
    }
  },
  emits: ['submit', 'closePopup']
}
  